import React from "react";
import { Provider } from "react-redux";
import { Toaster } from "sonner";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { AdminRouteWrapper } from "./components/common/AdminRouteWrapper";
import NotFound from "./components/common/NotFound";
import { PinLockProvider } from "./components/common/PinLockProvider";
import { SessionProvider } from "./components/common/SessionProvider";
import { GlobalErrorModal } from "./components/molecules/GlobalErrorModal/GlobalErrorModal";
import { useScrollToTop } from "./hooks/useScrollToTop";

import { store } from "./store/store";

/**
 * MED-1453: toasts used to sit on screen forever and cover the header user
 * menu. They now auto-dismiss and carry a close button so they can also be
 * dismissed by hand. Configured once here so every `toast.*` call benefits.
 */
export const TOASTER_OPTIONS = {
  richColors: true,
  position: "top-right",
  duration: 5000,
  closeButton: true,
} as const;

// Scroll to top component
const ScrollToTop: React.FC = () => {
  useScrollToTop("auto");
  return null;
};

function App() {
  return (
    <Provider store={store}>
      <Toaster {...TOASTER_OPTIONS} />
      <Router>
        <ScrollToTop />
        <SessionProvider>
          <PinLockProvider>
            <Routes>
              {/* Root redirect to admin dashboard */}
              <Route path="/" element={<Navigate to="/admin" />} />

              {/* Main dashboard - redirect to admin */}
              <Route path="/dashboard" element={<Navigate to="/admin" />} />

              {/* Admin dashboard routes */}
              <Route path="/admin/*" element={<AdminRouteWrapper />} />

              {/* 404 Not Found - catch all undefined routes */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </PinLockProvider>
        </SessionProvider>
      </Router>
      <GlobalErrorModal />
    </Provider>
  );
}

export default App;
